import { utcDay } from './utcDay';

export type ChartPoint = { date: string; views_gained?: number | null };
export type ChartSeriesInput = { start?: string | null; end?: string | null; points: readonly ChartPoint[] };
export type ChartSeriesPoint = { date: string; views_gained: number | null };

const DAY_MS = 86_400_000;
const isoDay = (timestamp: number) => new Date(timestamp).toISOString().slice(0, 10);

/** Builds a UTC daily series. Missing days deliberately remain null: no growth is invented. */
export function buildChartSeries({ start, end, points }: ChartSeriesInput): ChartSeriesPoint[] {
  const byDate = new Map<string, number | null>();
  for (const point of points) {
    if (utcDay(point.date) === null) continue;
    byDate.set(point.date, typeof point.views_gained === 'number' && Number.isFinite(point.views_gained)
      ? point.views_gained
      : null);
  }

  const pointDates = [...byDate.keys()].sort();
  let rangeStart = utcDay(start);
  let rangeEnd = utcDay(end);
  if (rangeStart === null) rangeStart = pointDates.length ? utcDay(pointDates[0]) : null;
  if (rangeEnd === null) rangeEnd = pointDates.length ? utcDay(pointDates.at(-1)) : null;
  if (rangeStart === null || rangeEnd === null || rangeStart > rangeEnd) return [];

  const series: ChartSeriesPoint[] = [];
  for (let day = rangeStart; day <= rangeEnd; day += DAY_MS) {
    const date = isoDay(day);
    series.push({ date, views_gained: byDate.get(date) ?? null });
  }
  return series;
}
